import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";
import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: styledHeaderText(t("newProject.dialogHeader", { ns: "dialogs" })),
        icon: "map",
      },
      meta: {
        aliasLabel: t("newProject.projectTitle", { ns: "dialogs" }),
        descriptionLabel: t("newProject.projectDescription", { ns: "dialogs" }),
        loaderLabel: t("newProject.uploadPreview", { ns: "dialogs" }),
      },
      applyText: t("actions.create", { ns: "common" }),
    }),
    [t],
  );
};
